<template>
  <div class="hold">
    <h3 class="title">
      Profile Picture
      <svg v-if="$auth.user().progress.pic" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" width="512px" height="512px" viewBox="0 0 352.62 352.62" style="enable-background:new 0 0 352.62 352.62;" xml:space="preserve"><g><g><path d="M337.222,22.952c-15.912-8.568-33.66,7.956-44.064,17.748c-23.867,23.256-44.063,50.184-66.708,74.664   c-25.092,26.928-48.348,53.856-74.052,80.173c-14.688,14.688-30.6,30.6-40.392,48.96c-22.032-21.421-41.004-44.677-65.484-63.648   c-17.748-13.464-47.124-23.256-46.512,9.18c1.224,42.229,38.556,87.517,66.096,116.28c11.628,12.24,26.928,25.092,44.676,25.704   c21.42,1.224,43.452-24.48,56.304-38.556c22.645-24.48,41.005-52.021,61.812-77.112c26.928-33.048,54.468-65.485,80.784-99.145   C326.206,96.392,378.226,44.983,337.222,22.952z M26.937,187.581c-0.612,0-1.224,0-2.448,0.611   c-2.448-0.611-4.284-1.224-6.732-2.448l0,0C19.593,184.52,22.653,185.132,26.937,187.581z" data-original="#000000" class="active-path" data-old_color="#000000" fill="#639440"/></g></g></svg>
    </h3>
    <div class="panel-body elevated">
      <div class="card-body">
        <div class="row">
          <div class="col-md-5">
            <div class="profile-pic-container">
              <div id="app" style="text-align: center">
                <div :style="{backgroundImage: `url(${url})`}" class="profile-picture-scoped"></div>
                <!-- <VueImageUploadCroppie :defaultImage.sync="url" :height="300" :width="300" :circle="true" :trans="trans"></VueImageUploadCroppie> -->
                <span style="display: flex; flex-direction: column; justify-content: center; align-items: center;">
                  <b-button class="btn-info mt-3 btn-sm" v-b-modal.modal-multi-1>Upload Image</b-button>
                  <i><small>(Max: 2MB)</small></i>
                </span>
              </div>

              <b-modal  id="modal-multi-1" class="modal_profile" size="md" title="Update Profile Picture" hide-footer>
                <div class="mt-3 mb-3" style="width: 100%; height:100%; display: inline-block;">
                  <vue-cropper
                      ref='cropper'
                      :guides="true"
                      :view-mode="2"
                      drag-mode="crop"
                      :auto-crop-area="0.5"
                      :min-container-height="300"
                      :background="true"
                      :rotatable="true"
                      :src="url"
                      alt="Source Image"
                      :img-style="{ 'width': '100%', 'height': '300px' }">
                  </vue-cropper>
                  <div class="mt-5">
                    <input type="file" name="image" accept="image/*" class="btn  btn-sm"  @change="setImage" />
                    <b-button id="btnShow"  v-if="url != ''"  class=" float-right btn btn-crop btn-success"  @click="cropImage(); submit()">Crop</b-button>
                  </div>
                </div>
              </b-modal>
            </div>

            <p class="bold">Here are some sample photos to guide you.</p>
            <div class="col-md-12">
              <div class="profile-pic-container">
                <img :src="sample1" class="img-thumbnail rounded" style="width:40%">
                <img :src="sample2" class="img-thumbnail round" style="width:40%">
              </div>
            </div>
          </div>

          <div class="col-md-1"></div>
          <div class="col-md-5" style="line-height: 200%;">
            <p>Prepclass is a professional community and as such, we expect all our users to upload professional photos to attract clients to you. Please make sure the photo clearly shows your face and ensure you have a smile. <b>Photos that do not meet our community guidelines will be rejected and profile will not be updated.</b></p>

            <p>
              <strong>Also note that:</strong>
            </p>
            <div>
              <p class="bold">1. Photo must be high quality, friendly, and professional</p>
              <p class="bold">2. Photo must be bright and clear, not dull and dark</p>
              <p class="bold">3. Background of the photo must look neat and presentable</p>
              <p class="bold">4. Do not upload passport, pdf, scanned or framed photo</p>
              <br>
            </div>
            <div class="row">
              <div class="col mb-2">

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import swal from 'sweetalert';
  import { mapMutations } from 'vuex';
  import VueCropper from 'vue-cropperjs';


  export default {
    components: {
      VueCropper
    },
    name: 'profile-picture',
    data() {
      return {
        submitting: false,
        url: this.$auth.user().profile_pic || 'https://crm.prepclassng.com/crm/images/picture-default.png?ba6d3e',
        sample1: window.location.hostname.indexOf('localhost') !== -1 ? 'https://prepcrm.test/img/sample1.jpeg' : 'https://crm.prepclassng.com/img/sample1.jpeg',
        sample2: window.location.hostname.indexOf('localhost') !== -1 ? 'https://prepcrm.test/img/sample2.jpeg' : 'https://crm.prepclassng.com/img/sample2.jpeg',
        sample3: window.location.hostname.indexOf('localhost') !== -1 ? 'https://prepcrm.test/img/sample3.jpeg' : 'https://crm.prepclassng.com/images/sample3.jpeg',
        sample4: window.location.hostname.indexOf('localhost') !== -1 ? 'https://prepcrm.test/img/sample4.png' : 'https://crm.prepclassng.com/img/sample4.png',
        trans: {
          'cropImage': 'Select Image',
          'chooseImage':'Choose Image',
          'confirmCutting': 'Save Image'
        },
        cropImg: '',
        modalStyle: ['myclass'],
        modalShow: false,
      };
    },
    methods: {
      ...mapMutations('profile', {
        updateProgress: 'UPDATE_PIC'
      }),
      selectFile() {
        this.$refs.pic.click();
      },
      setImage(e) {
        const file = e.target.files[0];

        if (!file.type.includes('image/')) {
          alert('Please select an image file');
          return;
        }

        if (typeof FileReader === 'function') {
          const reader = new FileReader();

          reader.onload = (event) => {
            this.url = event.target.result;
            // rebuild cropperjs with the updated source
            this.$refs.cropper.replace(event.target.result);
          };

          reader.readAsDataURL(file);
        } else {
          alert('Sorry, FileReader API not supported');
        }
      },
      cropImage() {
        // get image data for post processing, e.g. upload or setting image src
        this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
        this.url = this.cropImg;
      },
      rotate() {
        // guess what this does :)
        this.$refs.cropper.rotate(90);
      },
    async shouldUnVerify() {
      if (this.$auth.user().verified) {
        const proceed = await swal({
          title: 'Are you Sure?',
          text: 'Please note that this action would unverify you, and you\'ll have to wait to be re-verified.',
          icon: 'warning',
          buttons: ['Don\'t bother', 'Continue >>>'],
        });
        return proceed;
      } else {
        return true;
      }
    },
      async submit(data) {
        const shouldEnd = await swal({
          title: "Are you sure?",
          text: "Sure you want to update your profile picture",
          buttons: {
            confirm: {
              text: "Yes",
              closeModal: false
            },
            cancel: true
          }
        });
        const canProceed = this.shouldUnVerify();
        if (shouldEnd && canProceed) {
          this.submitting = true;
          this.$http
                  .post(`${BASE_API}/v1/tutor/profile/pic`, {pic: this.url})
                  .then((res) => {
                    this.$auth.fetch();
                    this.updateProgress();
                    const data = res.data.data;
                    this.url = data.url;
                    this.submitting = false;
                    this.$root.$emit('bv::hide::modal', 'modal-multi-1', '#btnShow')
                    swal({
                      title: 'Success',
                      text: 'Your profile Picture was updated successfully, ',
                      icon: 'success',
                      buttons: ['Cancel', 'Next ➜']
                    }).then((value) => {
                      if (value) {
                        this.submitting = false;
                        this.$emit('next');
                      }
                    });
                  })
                  .catch(() => {
                    swal('Sorry', 'Something went wrong. please try again', 'danger');
                  })
                  .then(() => {
                    this.submitting = false;
                  });
        }
      }
    },
    watch: {
      // url: function(value) {
      //   if (value) {
      //     this.submit(value);
      //   }
      // }
    },
  };
</script>

<style lang="scss" scoped>
  .hold {
    margin-top: 15px;
  }
  .panel-body {
    padding: 10px !important;
  }
  .cropper-container .cropper-bg {
    width:100% !important;
  }
  .elevated {
    overflow: hidden;
    border-radius: 4px;
    box-shadow: 0 2px 2px 0 rgba(150,150,150,0.14), 0 3px 1px -2px rgba(150,150,150,0.12), 0 1px 5px 0 rgba(150,150,150,0.2);
  }
  .submit-button {
    width: 130px;
    height: 38px;
    line-height: 38px;
    padding: 0 10px;
    text-align: center;
    border-radius: 4px;
    font-size: 14px;
    vertical-align: middle;
    box-shadow: 0 2px 2px 0 rgba(40, 167, 69, 0.14), 0 3px 1px -2px rgba(40, 167, 69, 0.12), 0 1px 5px 0 rgba(40, 167, 69, 0.2);
    // float: right;
    &:focus {
      outline: 0 !important;
      box-shadow: none !important;
      &:active {box-shadow: none !important;}
    }
  }
  .title {
    svg {
      float: right;
      height: 18px;
      width: 18px;
      margin: 0 15px;
    }
  }
  .bold {font-weight: 600; margin: 10px 0;}
  .profile-picture-scoped {
    width: 300px;
    height: 300px;
    overflow: hidden;
    margin-left: auto;
    margin-right: auto;
    border-radius: 300px;
    background-size: auto 100%;
    background-repeat: no-repeat;
    background-position: center center;
  }
  @media only screen and (max-width: 600px) {
    .hold {margin-bottom: 35px; margin-top: 20px;}
    .title {font-size: 16px;}
    div.vodal-dialog {
      width:0px !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/Profile/ProfilePicture.vue